import { render } from "./orderUnPatient.vue?vue&type=template&id=4b474cf4"
import script from "./orderUnPatient.vue?vue&type=script&lang=js"
export * from "./orderUnPatient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__